<button class="ws-filter-chip"
        [class.ws-filter-chip--active]="model"
        (click)="onClick()">
  <ng-content></ng-content>
</button>
